import React, { useReducer, useContext, useEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers';
import { api } from '../../../services/api';
import { Box, Tooltip, TextField } from '@mui/material'
import DefaultModal from '../../Utils/DefaultModal';
import ColorButton from '../../Buttons/ColorButton';
import toast from 'react-hot-toast';
import validateData from './validateData';

const url = '/catracas/'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Catraca ${res.status === 201 ? 'adicionada' : 'editada'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Catraca não pôde ser ${!data.id ? 'adicionada' : 'editada.'} Motivo: ${res.data}`)
    setLoader(false)
}

const EditCatraca = ({ data, reloadData, setLoader, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        nome: '',

        ...data,
        id: data.id ? data.id : 0
    })

    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                open={true}
                title={
                    `${getTitle(state)} Catraca`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >

                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    value={state.nome}
                                    onChange={(e) => { setState({ 'nome': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />

        </>
    )
}

export default EditCatraca;